import React from "react";

const Contact = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-white via-cyan-50 to-white overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-20 right-20 w-72 h-72 bg-cyan-400/30 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 left-20 w-72 h-72 bg-navy-900/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block bg-cyan-400/10 border border-cyan-400/30 rounded-full px-6 py-2 mb-6">
              <span className="text-sm font-bold text-navy-900 tracking-wide">
                GET IN TOUCH
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-black text-navy-900 leading-none mb-6">
              Contact <span className="text-cyan-500">Us</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 leading-relaxed">
              Have questions? Need a quote? We're here to help.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-black text-navy-900 mb-8 text-center">
              Get In <span className="text-cyan-500">Touch</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {[
                {
                  icon: "📞",
                  title: "Phone",
                  content: "0330 054 5944",
                  link: "tel:03300545944",
                  subtitle:
                    "Call us anytime - 24/7 emergency service available",
                },
                {
                  icon: "✉️",
                  title: "Email",
                  content: "info@shinycrew.com",
                  link: "mailto:info@shinycrew.com",
                  subtitle: "We respond within 2 hours during business hours",
                },
                {
                  icon: "📍",
                  title: "Location",
                  content: "86-90 Paul Street, London, EC2A 4NE",
                  subtitle: "Serving London and surrounding areas",
                },
                {
                  icon: "⏰",
                  title: "Business Hours",
                  content: "Mon-Fri: 8AM - 7:30PM",
                  subtitle: "Sat-Sun: Closed",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-4 p-6 bg-gray-50 rounded-xl border-2 border-gray-200 hover:border-cyan-400"
                >
                  <div className="text-4xl flex-shrink-0">{item.icon}</div>
                  <div>
                    <h3 className="text-lg font-bold text-navy-900 mb-1">
                      {item.title}
                    </h3>
                    {item.link ? (
                      <a
                        href={item.link}
                        className="text-xl text-cyan-500 hover:text-cyan-600 font-semibold"
                      >
                        {item.content}
                      </a>
                    ) : (
                      <p className="text-xl text-gray-800 font-semibold">
                        {item.content}
                      </p>
                    )}
                    <p className="text-sm text-gray-600 mt-1">
                      {item.subtitle}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Emergency Notice */}
            <div className="bg-gradient-to-br from-coral-400 to-coral-500 rounded-2xl p-6 text-white text-center">
              <div className="flex items-center justify-center space-x-3 mb-3">
                <span className="text-3xl">🚨</span>
                <h3 className="text-xl font-bold">Emergency Services</h3>
              </div>
              <p className="text-white/90 mb-3">
                Locked out or need urgent assistance? Our 24/7 emergency
                locksmith service is always available.
              </p>
              <a
                href="tel:03300545944"
                className="inline-block px-6 py-3 bg-white text-coral-500 font-bold rounded-lg hover:bg-gray-100"
              >
                CALL NOW: 0330 054 5944
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-black text-navy-900 mb-4">
                Quick <span className="text-cyan-500">Answers</span>
              </h2>
              <p className="text-xl text-gray-600">
                Frequently asked questions about our services
              </p>
            </div>

            <div className="space-y-4">
              {[
                {
                  q: "How quickly can you respond to my request?",
                  a: "We respond to all inquiries within 2 hours during business hours. For emergency locksmith services, we offer 24/7 response with an average arrival time of under 30 minutes.",
                },
                {
                  q: "Do you offer free quotes?",
                  a: "Yes! We provide free, no-obligation quotes for all our services. Simply fill out the form above or give us a call, and we'll provide a detailed estimate.",
                },
                {
                  q: "What areas do you serve?",
                  a: "We serve London and surrounding areas from our office at 86-90 Paul Street, London, EC2A 4NE. Contact us to confirm if we cover your specific location.",
                },
                {
                  q: "Are you insured and licensed?",
                  a: "Absolutely. We are fully licensed, insured, and bonded. All our team members are background-checked and professionally trained.",
                },
              ].map((faq, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-cyan-400"
                >
                  <h3 className="text-xl font-bold text-navy-900 mb-3">
                    {faq.q}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
